import { render, staticRenderFns } from "./StartStatistic.vue?vue&type=template&id=615e176b&scoped=true&"
import script from "./StartStatistic.vue?vue&type=script&lang=js&"
export * from "./StartStatistic.vue?vue&type=script&lang=js&"
import style0 from "./StartStatistic.vue?vue&type=style&index=0&id=615e176b&lang=scss&scoped=true&"
import style1 from "./StartStatistic.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e176b",
  null
  
)

export default component.exports